import { CommandAction } from "@/contexts/command-palette-context"
import type { SearchResult } from "@/schema/search"

export function filterCommandActions(actions: CommandAction[], query: string): CommandAction[] {
  if (!query.trim()) return actions

  const normalized = query.toLowerCase()
  return actions.filter(
    (action) =>
      action.label.toLowerCase().includes(normalized) ||
      action.keywords.some((keyword) => keyword.toLowerCase().includes(normalized))
  )
}

export function resultKey(result: SearchResult): string {
  return `${result.type}::${result.id}`
}

export function getRecordTypeLabel(type: SearchResult["type"]): string {
  const labels: Record<SearchResult["type"], string> = {
    person: "Person",
    household: "Household",
    client: "Client",
    past_client: "Past client",
    prospect: "Prospect",
    contact: "Contact",
    opportunity: "Opportunity",
    sms_message: "Message",
    business: "Business",
    trust: "Trust",
    user: "User",
    custodian_account: "Custodian account",
    financial_account: "Account",
    insurance_policy: "Insurance policy",
  }
  return labels[type] || type
}

export function isEmail(query: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(query.trim())
}

export function isPhoneNumber(query: string): boolean {
  const phoneRegex = /^[\d\s\-\(\)\+]{10,}$/
  return phoneRegex.test(query.trim())
}

export function isName(query: string): boolean {
  const words = query.trim().split(/\s+/).filter(Boolean)
  return words.length >= 2 && words.every((word) => /^[a-zA-Z]+$/.test(word))
}
